module.exports = __webpack_public_path__ + "img/preview_pulldown.7c11a57d.png";